import { BuildingIncidents } from "../../Molecules/BuildingDetails/BuildingDetail/BuildingIncidents/BuildingIncidents";
import { DigitalTwinPage } from "../../Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwin";
import { ItemDetail } from "../../Molecules/WeatherServiceDetils/ItemDetail";

export const RegisterWeatherServiceHelper = [
    {
        name: "Overview",
        label: "overview",
        path: "#overview",
        submenus: null,
        component: [ItemDetail, BuildingIncidents, DigitalTwinPage],
        buttons: ['Details', 'Incidents', 'Digital Twin']
      }
];